import { render, staticRenderFns } from "./UserProfilePicture.vue?vue&type=template&id=384c2a45"
import script from "./UserProfilePicture.vue?vue&type=script&lang=ts"
export * from "./UserProfilePicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports